import { clearPreferredAudioOutputId, getPreferredAudioOutputId } from '../../../utils/livekit-audio-output';

import { useRoomContext } from '@livekit/components-react';
import { ConnectionState, RoomEvent } from 'livekit-client';
import { useEffect } from 'react';

const useAudioOutputPreference = () => {
	const room = useRoomContext();

	useEffect(() => {
		const apply = async () => {
			const preferred = getPreferredAudioOutputId();

			if (!preferred) {
				return;
			}

			try {
				await room.switchActiveDevice('audiooutput', preferred);
			} catch (error) {
				clearPreferredAudioOutputId();
			}
		};

		const reapply = async () => {
			const preferred = getPreferredAudioOutputId();
			const active = room.getActiveDevice('audiooutput');

			if (!preferred || active === preferred) {
				return;
			}

			const all = await navigator.mediaDevices.enumerateDevices().catch(() => []);
			const devices = all.filter(device => device.kind === 'audiooutput');

			if (!devices.some(device => device.deviceId === preferred)) {
				clearPreferredAudioOutputId();

				return;
			}

			if (active && devices.some(device => device.deviceId === active)) {
				return;
			}

			await apply();
		};

		room.on(RoomEvent.Connected, apply);
		room.on(RoomEvent.MediaDevicesChanged, reapply);

		if (room.state === ConnectionState.Connected) {
			apply();
		}

		return () => {
			room.off(RoomEvent.Connected, apply);
			room.off(RoomEvent.MediaDevicesChanged, reapply);
		};
	}, [room]);
};

export default useAudioOutputPreference;
